import React from 'react';
import { getTranslatedString } from 'helpers/i18n';

const styles = {
  page: {
    textAlign: 'center',
    marginTop: '50px',
    fontSize: '18px',
    padding: '1rem',
  },
  errorImage: {
    maxWidth: '250px',
    width: '40%',
    height: 'auto',
  },
  h1: {
    fontSize: '20px',
  },
};

class VerificationFailed extends React.Component {
  render() {
    return (
      <div style={styles.page}>
        <img
          style={styles.errorImage}
          src="/verification_failure.svg"
          alt="Invitation token is invalid"
        />
        <h1 style={styles.h1}>{getTranslatedString('onboarding.tenant.verificationFailed')}</h1>
        <p>{getTranslatedString('onboarding.tenant.contactNewInvitation')}</p>
      </div>
    );
  }
}

export default VerificationFailed;
